import { BaseMountingRailArticleProjectProcessor } from './base-mounting-rail-article-project.processor';
import { RangeOnLineArticleData } from '@project/components/article/model/range-on-line-article-data';
import { AlertButton } from '@shared/alert/alertButton';
import { ArticleContainer } from '@3d-scene/model3d/article-container';

export class McsArticleProjectProcessor extends BaseMountingRailArticleProjectProcessor {
  protected createRangeOnLineArticleDataByArticles(articleContainers: ArticleContainer[]): RangeOnLineArticleData[] {
    if (this.projectModel && this.projectModel.user && this.projectModel.user.hasPermission("ADD_MODULES_TO_MCS_PROJECT")) {
      return super.createRangeOnLineArticleDataByArticles(articleContainers);
    } else {
      this.alertHelper.showAlert(
        'articleCreationManager.title.error_connect_on_mcs_rail',
        'articleCreationManager.message.error_connect_on_mcs_rail',
        undefined, [AlertButton.YES], "error");
      return [];
    }
  }

  public isReplaceOperationAvailable(): boolean {
    return false;
  }
}
